import { Snackbar } from '@/shared/components/Snackbar';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getMyProfile } from '@/epics/userProfile/api/userProfileApiService';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogAction,
} from '@/shared/components/Dialog/Dialog';

const MODAL_DISMISSED_KEY = 'profileCompletionModalDismissed';

// Icon matching the design: person card + warning circle overlay
const CompleteProfileIcon = () => (
  <div className="relative flex justify-center mb-2">
    {/* Yellow rounded card with person icon */}
    <div className="w-20 h-16 bg-warning-90 rounded-2xl flex items-center justify-center">
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
          fill="#1C1B1F"
          fillOpacity="0.6"
        />
      </svg>
    </div>
    {/* Warning circle overlay */}
    <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-8 h-8 bg-warning-80 rounded-full flex items-center justify-center border-2 border-neutral-100">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
          fill="#E65100"
        />
      </svg>
    </div>
  </div>
);

const CompleteProfileModal = ({
  open,
  onSkip,
  onSetup,
}: {
  open: boolean;
  onSkip: () => void;
  onSetup: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onSkip}
    closeOnOverlayClick={false}
    maxWidth={360}
  >
    <div className="flex flex-col items-center px-6 pt-8 pb-2">
      <CompleteProfileIcon />
      <h2
        className="text-neutral-10 font-medium text-center mt-6"
        style={{ fontSize: 24, lineHeight: '32px' }}
      >
        Uzupełnij profil
      </h2>
    </div>
    <DialogContent>
      Skonfiguruj profil, aby korzystać ze spersonalizowanego i płynnego
      działania aplikacji.
    </DialogContent>
    <DialogFooter className="justify-center gap-3 pb-6 pt-4">
      <DialogAction
        label="Pomiń na razie"
        variant="secondary"
        onClick={onSkip}
      />
      <DialogAction
        label="Skonfiguruj profil"
        variant="primary"
        onClick={onSetup}
      />
    </DialogFooter>
  </Dialog>
);

const TemperoryFile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showVerifySuccessSnackbar, setShowVerifySuccessSnackbar] =
    useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  useEffect(() => {
    if (location.state?.showVerifySuccess) {
      setShowVerifySuccessSnackbar(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(MODAL_DISMISSED_KEY);
    if (dismissed) {
      return;
    }

    void getMyProfile().then((result) => {
      if (
        result.success &&
        result.data?.user &&
        !result.data.user.isProfileComplete
      ) {
        setShowProfileModal(true);
      }
    });
  }, []);

  const handleSkip = () => {
    sessionStorage.setItem(MODAL_DISMISSED_KEY, 'true');
    setShowProfileModal(false);
  };

  const handleSetupProfile = () => {
    setShowProfileModal(false);
    sessionStorage.setItem('profile-first-login-flow', 'true');
    navigate('/Profil/Edytuj-profil');
  };

  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <div>Panel główny</div>
      <Snackbar
        open={showVerifySuccessSnackbar}
        message="Weryfikacja zakończona pomyślnie."
        variant="success"
        onClose={() => setShowVerifySuccessSnackbar(false)}
        autoHideDuration={10000}
        position="top-center"
        showCloseButton={true}
      />
      <CompleteProfileModal
        open={showProfileModal}
        onSkip={handleSkip}
        onSetup={handleSetupProfile}
      />
    </div>
  );
};

export default TemperoryFile;
